<template>
  <div class="third-party-company-config">
    <div class="container">
      <h1>开放平台 - 第三方公司配置</h1>

      <div class="header">
        <div class="search-box">
          <el-input
            v-model="searchForm.keyword"
            placeholder="搜索公司编码或名称"
            clearable
            @keyup.enter.native="handleSearch"
          />
          <el-button @click="handleSearch">搜索</el-button>
        </div>
        <el-button type="primary" @click="handleAdd">新增公司</el-button>
      </div>

      <el-table :data="tableData" border style="width: 100%; margin-top: 20px">
        <el-table-column prop="companyCode" label="公司编码" min-width="120" />
        <el-table-column prop="companyName" label="公司名称" min-width="150" />
        <el-table-column label="启用状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.enabledState === 'yes' ? 'success' : 'danger'">
              {{ scope.row.enabledState === 'yes' ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ipWhitelist" label="IP 白名单" min-width="200" show-overflow-tooltip />
        <el-table-column prop="serviceExpireDate" label="服务到期日期" min-width="150" />
        <el-table-column prop="storeCodeMapping" label="商城编码映射" min-width="150" />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        background
        layout="prev, pager, next, jumper, ->, total"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :current-page="pagination.pageNo"
        @current-change="handlePageChange"
      />
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="140px"
        label-position="right"
      >
        <div class="section-title">基本信息</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="公司编码" prop="companyCode">
              <el-input
                v-model="form.companyCode"
                placeholder="请输入公司编码"
                :disabled="isEdit"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="form.companyName" placeholder="请输入公司名称" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注信息"
          />
        </el-form-item>

        <div class="section-title">凭证配置</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="授权编码 (开发)">
              <el-input v-model="form.devAccessKeyId" placeholder="请输入或生成" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授权编码 (生产)">
              <el-input v-model="form.prodAccessKeyId" placeholder="请输入或生成" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="授权密匙 (开发)">
              <el-input v-model="form.devAccessKeySecret" readonly>
                <el-button slot="append" @click="generateKeyPair('dev')">生成</el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授权密匙 (生产)">
              <el-input v-model="form.prodAccessKeySecret" readonly>
                <el-button slot="append" @click="generateKeyPair('prod')">生成</el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="section-title">安全配置</div>
        <el-form-item label="启用状态">
          <el-select v-model="form.enabledState" placeholder="请选择">
            <el-option label="启用" value="yes" />
            <el-option label="禁用" value="no" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item>
          <el-checkbox v-model="form.ipWhitelistEnabled" :true-label="'yes'" :false-label="'no'">
            启用 IP 白名单
          </el-checkbox>
        </el-form-item> -->
        <el-form-item label="IP 白名单列表">
          <el-input
            v-model="form.ipWhitelist"
            type="textarea"
            :rows="3"
            placeholder="请输入 IP 地址，多个 IP 用逗号分隔，例如：192.168.1.1,192.168.1.2"
          />
        </el-form-item>

        <div class="section-title">服务到期配置</div>
        <el-form-item label="服务到期日期">
          <el-date-picker
            v-model="form.serviceExpireDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          />
        </el-form-item>

        <div class="section-title">业务配置</div>
        <el-form-item label="商城编码映射">
          <el-input v-model="form.storeCodeMapping" placeholder="请输入商城编码" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ThirdPartyCompanyConfig',
  data() {
    return {
      // 搜索表单
      searchForm: {
        keyword: ''
      },
      // 表格数据
      tableData: [],
      // 分页
      pagination: {
        total: 0,
        pageNo: 1,
        pageSize: 10
      },
      // 弹窗相关
      dialogVisible: false,
      isEdit: false,
      currentRow: null,
      // 表单数据
      form: {
        id: '',
        companyCode: '',
        companyName: '',
        remark: '',
        devAccessKeyId: '',
        devAccessKeySecret: '',
        prodAccessKeyId: '',
        prodAccessKeySecret: '',
        enabledState: '1',
        ipWhitelistEnabled: '0',
        ipWhitelist: '',
        serviceExpireDate: '',
        storeCodeMapping: ''
      },
      // 表单校验规则
      rules: {
        companyCode: [
          { required: true, message: '请输入公司编码', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ]
      },
      // 日期选择器配置
      pickerOptions: {
        disabledDate(time) {
          // 禁用今天之前的日期
          return time.getTime() < Date.now() - 86400000;
        }
      }
    };
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑公司信息' : '新增公司信息';
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    // 获取列表数据
    async fetchData() {
      try {
        const params = {
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize
        };
        if (this.searchForm.keyword) {
          params.keyword = this.searchForm.keyword;
        }
        const { code, result } = await this.$store.dispatch(
          'thirdCompanyOpenPlatformConfigQueryPageList',
          params
        );
        if (code == 0) {
          this.tableData = result.records || [];
          this.pagination.total = result.total || 0;
        }
      } catch (error) {
        this.$message.error('获取列表数据失败');
        console.error(error);
      }
    },
    // 搜索
    handleSearch() {
      this.pagination.pageNo = 1;
      this.fetchData();
    },
    // 分页变化
    handlePageChange(page) {
      this.pagination.pageNo = page;
      this.fetchData();
    },
    // 新增
    handleAdd() {
      this.isEdit = false;
      this.currentRow = null;
      this.resetForm();
      this.dialogVisible = true;
    },
    // 编辑
    handleEdit(row) {
      this.isEdit = true;
      this.currentRow = row;
      this.form = {
        id: row.id || '',
        companyCode: row.companyCode || '',
        companyName: row.companyName || '',
        remark: row.remark || '',
        devAccessKeyId: row.devAccessKeyId || '',
        devAccessKeySecret: row.devAccessKeySecret || '',
        prodAccessKeyId: row.prodAccessKeyId || '',
        prodAccessKeySecret: row.prodAccessKeySecret || '',
        enabledState: row.enabledState || 'yes',
        ipWhitelistEnabled: row.ipWhitelistEnabled || 'no',
        ipWhitelist: row.ipWhitelist || '',
        serviceExpireDate: row.serviceExpireDate || '',
        storeCodeMapping: row.storeCodeMapping || ''
      };
      this.dialogVisible = true;
    },
    // 重置表单
    resetForm() {
      this.form = {
        id: '',
        companyCode: '',
        companyName: '',
        remark: '',
        devAccessKeyId: '',
        devAccessKeySecret: '',
        prodAccessKeyId: '',
        prodAccessKeySecret: '',
        enabledState: 'yes',
        ipWhitelistEnabled: 'no',
        ipWhitelist: '',
        serviceExpireDate: '',
        storeCodeMapping: ''
      };
      this.$refs.form && this.$refs.form.resetFields();
    },
    // 弹窗关闭
    handleDialogClose() {
      this.resetForm();
    },
    // 生成密钥对
    async generateKeyPair(type) {
      try {
        const { code, result } = await this.$store.dispatch(
          'thirdCompanyOpenPlatformConfigGenerateAccessKeyPair'
        );
        if (code == 0) {
          if (type === 'dev') {
            this.form.devAccessKeyId = result.accessKeyId || '';
            this.form.devAccessKeySecret = result.accessKeySecret || '';
          } else {
            this.form.prodAccessKeyId = result.accessKeyId || '';
            this.form.prodAccessKeySecret = result.accessKeySecret || '';
          }
          this.$message.success('密钥生成成功');
        }
      } catch (error) {
        this.$message.error('密钥生成失败');
        console.error(error);
      }
    },
    // 保存
    handleSave() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;

        try {
          const params = { ...this.form };
          // 移除id字段（新增时）
          if (!this.isEdit) {
            delete params.id;
          }

          const action = this.isEdit
            ? 'thirdCompanyOpenPlatformConfigUpdate'
            : 'thirdCompanyOpenPlatformConfigAdd';

          const { code } = await this.$store.dispatch(action, params);

          if (code == 0) {
            this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
            this.dialogVisible = false;
            this.fetchData();
          }
        } catch (error) {
          this.$message.error(this.isEdit ? '编辑失败' : '新增失败');
          console.error(error);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.third-party-company-config {
  padding: 20px;

  .container {
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  h1 {
    font-size: 24px;
    margin-bottom: 20px;
    color: #333;
    font-weight: 500;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .search-box {
    display: flex;
    gap: 10px;
    align-items: center;

    .el-input {
      width: 220px;
    }
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 20px 0 15px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #e8e8e8;

    &:first-of-type {
      margin-top: 0;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}

::v-deep {
  .el-dialog__body {
    padding: 20px 30px 10px;
  }

  .el-form-item {
    margin-bottom: 18px;

    .el-input,
    .el-select {
      width: 220px;
    }
  }
}
</style>
